import React from "react";
import type {VoidFunctionComponent} from "react";

import {useDashboardUserTotalPointsLogic} from "./DashboardUserTotalPoints.logic";
import {UserSummaryStatsContainer} from "../../../components/dashboard/user-stats-container/UserSummaryStatsContainer";

export const DashboardUserTotalPoints: VoidFunctionComponent = () => {
  const {totalPoints} = useDashboardUserTotalPointsLogic();
  return <UserSummaryStatsContainer value={totalPoints ?? 0} label={`Total points earned`} />;
}
